<template>
    <div :class="imagetype">
    <NuxtImg
      v-if="src"
      :src="toImgixPath(src)"
      provider="imgix"
      format="webp"
      fit="crop"
      class="w-full"
      :modifiers="{ 
        ar: '1:1',
        auto: 'format,compress',        
        crop: 'faces,edges'
      }"/>
    </div>
</template>
  
    
<script setup>
    // Props
    const props = defineProps({
      src: {
        type: String,
        required: true
      },
      alt: {
        type: String,
        default: 'Image'
      },
      width: {
        type: [String, Number],
        default: 349
      },
      height: {
        type: [String, Number],
        default: 349
      },
      sizes: {
        type: String,
        default: 'sm:240px md:480px lg:720px xl:960px'
      },
      imagetype: {
        required: false,
        type: String,
        default: 'hoverimage'
      }
    });

    
    
    // Computed property to generate the imgix path
    const toImgixPath = (image) => {
      return image.replace('https://cdn.shopify.com/', '').replace(/\?v=\d+/, '');
    };
</script>
    
<style scoped>
@reference "../../assets/css/main.css";
  .product{
    @apply bg-gravaalightwarmgray;
  }

</style>